import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { ConfigurationSection } from '../../StyleComponents';
import { LeaveAndAbsenceDigestSetting } from '@shared/ui/organisms/settings/LeaveAndAbsenceDigestSetting';
import { MonthlyWhereaboutsSummarySetting } from '@shared/ui/organisms/settings/MonthlyWhereaboutsSummarySetting';
import { MonthlyOfficeSummarySetting } from '@shared/ui/organisms/settings/MonthlyOfficeSummarySetting';
import { MissingWhereaboutsReportSetting } from '@shared/ui/organisms/settings/MissingWhereaboutsReportSetting';
import { VisitorSummarySetting } from '@shared/ui/organisms/settings/VisitorSummarySetting';
import { AbsenceReportsSetting } from '@shared/ui/organisms/settings/AbsenceReportsSetting';

export function AutomatedReportingPanel() {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.automated-reporting-tab')}</HeadlineSmall>
      <ConfigurationSection>
        <BodyRegular>{t('company-settings-page.automated-reporting.description')}</BodyRegular>
      </ConfigurationSection>
      <LeaveAndAbsenceDigestSetting />
      <MissingWhereaboutsReportSetting />
      <MonthlyWhereaboutsSummarySetting />
      <MonthlyOfficeSummarySetting />
      <VisitorSummarySetting />
      <AbsenceReportsSetting />
    </>
  );
}
